import { ArrowRight2 } from 'iconsax-react';
import type { ReactNode } from 'react';
import { AvatarWithStatus } from '@/components/common/avatar-with-status';
import type { Group } from '@/models/group/group-info';
import type { Friend } from '@/models/user/friend';
import cn from '@/utils/merge-class-names';

interface Props {
  item:
    | Pick<Friend, 'FriendNickName' | 'FriendHeadImg' | 'RemarkName'>
    | Pick<Group, 'GroupName' | 'GroupImg' | 'Info' | 'UserCount'>;
  arrow?: boolean;
  className?: string;
  suffix?: ReactNode;
}

export function ContactListItem({ item, arrow = false, className, suffix }: Props) {
  return (
    <div className={cn('flex w-full min-w-0 items-center gap-4 rounded-s px-5 py-2 transition-colors', className)}>
      <AvatarWithStatus
        className='size-12'
        imageUrl={'FriendHeadImg' in item ? item.FriendHeadImg : item.GroupImg}
        label={'FriendNickName' in item ? item.FriendNickName : item.GroupName}
        defaultAvatar={'GroupImg' in item ? 'group' : 'user'}
        size={[48, 48]}
      />
      <div className='flex w-1/2 flex-1 flex-col items-stretch justify-center'>
        <span className='truncate break-all text-h2 '>
          {'FriendNickName' in item ? item.RemarkName || item.FriendNickName : item.GroupName}
          {'UserCount' in item && ` (${item.UserCount})`}
        </span>
        {'Info' in item && item.Info && <p className='truncate break-all text-sm text-gray-400'>{item.Info}</p>}
        {'FriendNickName' in item && item.RemarkName && (
          <span className='text-sm text-gray-400'>{item.FriendNickName}</span>
        )}
      </div>
      {suffix}
      {arrow && <ArrowRight2 size={20} />}
    </div>
  );
}
